import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const deleteScholarshipPreference = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/scholarships/scholarship-preferences/reset/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateScholarshipPreference = ({
  version = 'v1',
  params,
  payload,
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/scholarship-preferences/update/`,
      method: RequestMethod.PATCH,
      data: payload,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipPreference = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/scholarships/scholarship-preferences/retrieve/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipsList = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/scholarships/scholarships/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarship = ({ version = 'v1', scholarshipUUID } = {}) =>
  client
    .request({
      url: `${version}/scholarships/scholarships/${scholarshipUUID}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipsTagCategories = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/scholarships/tag-categories/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const favoriteScholarship = ({
  version = 'v1',
  params,
  scholarshipId,
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/favorite-scholarships/${scholarshipId}/favorite/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unfavoriteScholarship = ({
  version = 'v1',
  params,
  scholarshipId,
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/favorite-scholarships/${scholarshipId}/unfavorite/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const applyToScholarship = ({
  version = 'v1',
  params,
  scholarshipId,
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/aliased-applied-scholarships/${scholarshipId}/apply/`,
      method: RequestMethod.POST,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unapplyToScholarship = ({
  version = 'v1',
  params,
  scholarshipId,
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/aliased-applied-scholarships/${scholarshipId}/unapply/`,
      method: RequestMethod.DELETE,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getStudents = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/k12-users/students/with-scholarship-preferences/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipTags = ({ version = 'v1', params } = {}) =>
  client
    .request({
      url: `${version}/scholarships/tags/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getAppliedScholarship = ({ uuid, version = 'v1' } = {}) =>
  client
    .request({
      url: `${version}/scholarships/applied-scholarships/${uuid}/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateAppliedScholarship = ({
  uuid,
  payload,
  version = 'v1',
} = {}) =>
  client
    .request({
      url: `${version}/scholarships/applied-scholarships/${uuid}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getManagedScholarships = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/scholarships/manage-scholarships/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipSummary = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/scholarships/listing-summary/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getScholarshipCategories = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/scholarships/scholarship-category-search/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
